/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreHistoryManagementListOrderResponse } from './StoreHistoryManagementListOrderResponse';

export type StoreHistoryManagementListOrderResponseApiRespoonse = {
    data?: StoreHistoryManagementListOrderResponse;
    status?: StoreHistoryManagementListOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreHistoryManagementListOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

